$(document).ready(function() {
  $("#top_actions_container .cart_button_detail_desktop").on("click", function(
    e
  ) {
    e.preventDefault();
    $(".top_actions__package-specification").hide();
    $(".top_actions__phone-specification")
      .show()
      .css({ display: "flex" });

    $(".close").on("click", function() {
      $(".top_actions__phone-specification").hide();
      $(".top_actions__package-specification").show();
    });
  });

  $("#top_actions_container .cart_button_detail_mobile").on("click", function(
    e
  ) {
    e.preventDefault();
    $(".top_actions__package-specification").hide();
    $(".cart_button_detail_mobile").hide();
    $(".top_actions__phone-specification").show();
    $(".cart_button_detail_mobile_back").show();

    $(".cart_button_detail_mobile_back").on("click", function() {
      $(".top_actions__phone-specification").hide();
      $(".cart_button_detail_mobile_back").hide();
      $(".top_actions__package-specification").show();
      $(".cart_button_detail_mobile").show();
    });
  });
});
